import script from "./WaitRent.vue?vue&type=script&setup=true&lang=js"
export * from "./WaitRent.vue?vue&type=script&setup=true&lang=js"

import "./WaitRent.vue?vue&type=style&index=0&id=1cbc6989&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cbc6989"]])

export default __exports__